export const UNIVERSAL_STUDIO_SLUG = 'universal-pictures';
export const FOCUS_STUDIO_SLUG = 'focus-features';

export const BASE_REGION_CODE = 'base';